import { useMutation, useQueryClient } from "@tanstack/react-query";
import { recruitersService } from "@/services/recruitersService";
import { recruitersQueryKeys } from "@/hooks/queries/recruiters";

// mutations keys
export const recruitersMutationKeys = {
  all: ["recruiters"],
  list: () => [...recruitersMutationKeys.all, "list"],
  details: (id) => [...recruitersMutationKeys.all, "detail", id],
};


// create recruiter
export const useCreateRecruiter = () => {
  return useMutation({
    mutationKey: recruitersMutationKeys.list(),
    mutationFn: (recruiter) => recruitersService.createRecruiter(recruiter),
  });
};

export const useUploadRecruiterPdf = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [...recruitersMutationKeys.all, "upload-pdf"],
    mutationFn: ({ recruiterId, file }) =>
      recruitersService.uploadRecruiterPdf(recruiterId, file),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: recruitersQueryKeys.list() });
    },
  });
};



